var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 0)?_c('div',{staticClass:"notifications-root",attrs:{"id":"notifications-root"}},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"notifications-root__item"},[_c('notifications-item',_vm._b({},'notifications-item',item,false))],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }